import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Server name", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Port number", -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Log in")
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Log out")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Shutdown Server")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_CardBody = _resolveComponent("CardBody")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, { text: _ctx.headrMsg }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, null, {
        default: _withCtx(() => [
          _createVNode(_component_CardBody, null, {
            default: _withCtx(() => [
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                      class: "w3-input",
                      type: "text",
                      style: {"width":"90%"},
                      required: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serverName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.serverName]
                    ]),
                    _hoisted_2
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                      class: "w3-input",
                      type: "number",
                      style: {"width":"90%"},
                      required: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.serverPort) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.serverPort]
                    ]),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createVNode(_component_Btn, { onClick: _ctx.doLogin }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createVNode(_component_Btn, { onClick: _ctx.doLogout }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createVNode(_component_Btn, {
              ml: true,
              onClick: _ctx.doShutdown
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["text"]))
}